export enum sortDirections {
  Asc = 0,
  Desc = 1,
}

export enum JobsSortBy {
  id = "id",
  jobTitle = "jobTitle",
  createdOn = "createdOn",
  createdBy = "createdBy",
  numberOfOpportunities = "numberOfOpportunities",
  totalNumberOfApplicants = "totalNumberOfApplicants",
  jobType = "jobType",
  jobLocation = "jobLocation",
  workEnvironment = "workEnvironment",
  status = "status",
}

export enum PackageSortBy {
  id = "id",
  name = "name",
  packageType = "packageType",
  priceCitizens = "priceCitizens",
  priceNonCitizens = "priceNonCitizens",
  activeMembersCount = "activeMembersCount",
  status = "status",
}

export enum NewDashboardTableSortBy {
  id = "id",
  name = "name",
  packageType = "packageType",
  priceCitizens = "priceCitizens",
  priceNonCitizens = "priceNonCitizens",
  activeMembersCount = "activeMembersCount",
  status = "status",
}

export enum JobsApplicantsSortBy {
  id = "id",
  name = "name",
  applyDate = "applyDate",
  phoneNo = "phoneNo",
  email = "email",
  status = "status",
}

export enum ApplicantStatus {
  Draft = 1,
  Pending = 2,
  Fit = 3,
  NotFit = 4,
}

export enum JobsStatus {
  Draft = 1,
  Open = 2,
  Closed = 3,
}

export enum FileType {
  CoverLetterAttachment = 100,
  ResumeAttachment = 101,
  Certificate = 102,
}
